/*
 * @Author: your name
 * @Date: 2021-12-13 21:56:11
 * @LastEditTime: 2021-12-13 22:48:15
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xueersi.com-transition/mall-www-source/src/networks/api/AddPurchase/index.js
 */
import axios from 'axios'
const proxyUrl = process.env.NODE_ENV === 'development' ? '/mall-proxy/': ''

export default {
  getCourseDetail: ({ courseId, classId = 0 }, config = {}) =>
    axios.get(`${proxyUrl}detail/1/${courseId}/${classId}`, config),
  getSearchSift: (config = {}) => axios.get(`${proxyUrl}incPurchase/searchSift`, config),
  // 课程标准化-获取课程筛选条件
  // getSearchSift: ({location, provinceId, gradeId, courseType, promotionId, ruleId}, config = {}) => axios.get(`courses/sift/1/${location}/${provinceId}/${gradeId}/${courseType}/${promotionId}/${ruleId}`)
  getCourseList: (config = {}) => axios.get(`${proxyUrl}incPurchase/courseList`, config),
  // 课程标准化--加价购获取课程列表
  // getCourseList: ({
  //   location,
  //   provinceId,
  //   gradeId,
  //   courseType,
  //   subject,
  //   page
  // }, config = {}) => axios.get(`courses/list/1/${location}/${provinceId}/${gradeId}/${courseType}/${subject}/${page ? page + '/' : ''}`, config), // 课程标准化
  checkCourse: (data, config = {}) => axios.post(`${proxyUrl}incPurchase/checkCourse`, data, config)
}



// WEBPACK FOOTER //
// ./src/networks/api/AddPurchase/index.js